import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { OrdersDetailFormsDetailModule } from './controllers/OrdersDetailFormsDetailController';

export const OrderDetailsFormsDetailView =
angular.module( 'acme.view.application.orders.detail.forms.detail', [
  uiRouter,
  'ui.bootstrap',
  'acme.common.service.api',
  OrdersDetailFormsDetailModule,
  'acme.common.directive.printerFriendlyLink'
])

.config(function config( $stateProvider: StateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  const ordersDetailFormsDetail = {
        name: 'application.orders.detail.forms.detail',
        url: '/:responseId/detail',
        views: {
          "subview-main@application.orders": {
            controller: 'OrdersDetailFormsDetailController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/orders/detail/forms/detail/detail.tpl.html'
          }
        },
        data: {
          pageTitle: ' Form Details  ',
          /** Secure With Permissions **/
          permissions: ['ORDER_VIEW']
        },
        resolve: {
          ResponseData: [ 'ApiService', '$stateParams',  function(ApiService, $stateParams) {
            return ApiService.orders.forms.response({
              orderId: $stateParams.orderId,
              responseId: $stateParams.responseId
            });
          }]
        }
      };

    $stateProvider
      .state(ordersDetailFormsDetail);
}).name;
